import { BrowserRouter, Routes, Route } from 'react-router-dom';
import CataloguePage from './pages/CataloguePage';
import SignupPage from './pages/SignupPage';
import OwnerDashboard from './pages/OwnerDashboard';
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import QueuePage from "./pages/QueuePage";
import BookingPage from "./pages/BookingPage";
import LookbookPage from './pages/LookbookPage';
import RewardsPage from './pages/RewardsPage';
import RedeemPage from './pages/RedeemPage';
import StaffPage from './pages/StaffPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/c/:slug" element={<CataloguePage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/dashboard" element={<OwnerDashboard />} />
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/book/:slug" element={<BookingPage />} />
        <Route path="/q/:queueId" element={<QueuePage brandName="QKARD" accentColor="#6c63ff" />} />
        <Route path="/look/:slug" element={<LookbookPage />} />
        <Route path="/rewards/:slug" element={<RewardsPage />} />
        <Route path="/redeem/:slug" element={<RedeemPage />} />
        <Route path="/staff/:slug" element={<StaffPage />} />
        <Route path="*" element={<div style={{ padding: 32, textAlign: 'center', fontFamily: 'sans-serif', color: '#666' }}>Page not found</div>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
